import { render, staticRenderFns } from "./OnlineCourse.vue?vue&type=template&id=7d865208&scoped=true"
import script from "./OnlineCourse.vue?vue&type=script&lang=js"
export * from "./OnlineCourse.vue?vue&type=script&lang=js"
import style0 from "./OnlineCourse.vue?vue&type=style&index=0&id=7d865208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d865208",
  null
  
)

export default component.exports